import { CheckCircle2, AlertTriangle, Clock, MessageSquare } from "lucide-react";

const Header = ({ a }) => {
  if (a.marking_status === "awaiting") {
    return (
      <div className="flex items-center gap-2">
        <Clock className="text-amber-500" size={18} />
        <h3 className="font-heading font-semibold">Awaiting tutor marking — {a.score_pct}% provisional</h3>
      </div>
    );
  }
  return (
    <div className="flex items-center gap-2">
      {a.passed ? <CheckCircle2 className="text-green-600" size={18} /> : <AlertTriangle className="text-amber-500" size={18} />}
      <h3 className="font-heading font-semibold">{a.passed ? "Passed" : "Not yet"} — {a.score_pct}%</h3>
    </div>
  );
};

const AnswerRow = ({ a, i, awaiting }) => (
  <div className="text-xs border border-slate-100 rounded p-2 space-y-1">
    <p className="font-medium">{i + 1}. {a.prompt}</p>
    {a.kind === "mcq" ? (
      <p className={a.correct ? "text-green-700" : "text-rose-600"}>{a.correct ? "Correct" : "Incorrect"}</p>
    ) : awaiting ? (
      <p className="text-slate-600">Awaiting tutor marking</p>
    ) : (
      <>
        <p className="text-slate-700">Tutor awarded {a.awarded_points ?? 0} / {a.max_points}</p>
        {a.feedback && <p className="flex items-start gap-1 rounded bg-green-50 p-2 text-green-900"><MessageSquare size={11} className="mt-0.5 shrink-0" /> {a.feedback}</p>}
      </>
    )}
  </div>
);

export const LearnerAttemptCard = ({ attempt, testId }) => {
  const awaiting = attempt.marking_status === "awaiting";
  return (
    <div className="border border-border rounded-md bg-white p-4 space-y-2" data-testid={testId}>
      <Header a={attempt} />
      <p className="text-xs text-muted-foreground">
        Pass mark {attempt.pass_mark_pct}% · submitted {new Date(attempt.submitted_at).toLocaleString()}
        {awaiting && " · the provisional score counts multiple-choice answers only."}
      </p>
      <div className="space-y-2">
        {(attempt.answers || []).map((a, i) => <AnswerRow key={i} a={a} i={i} awaiting={awaiting} />)}
      </div>
    </div>
  );
};
